import { mediaQuery, typo } from '@design-system/styles'
import styled from '@emotion/styled'

const S = {
  AiAnalysisBanner: styled.div`
    display: flex;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: var(--Radius-100);
    background: var(--Colors-Purple-50);
    color: var(--Colors-Purple-600);
    ${typo.caption01};
    font-weight: 600;
    word-break: keep-all;
  `,
  ResponsiveBreak: styled.br`
    display: none;

    ${mediaQuery.large} {
      display: block;
    }
  `,
}

export default S
